export default __webpack_public_path__ + "static/media/14.bfad9774.jpg";